export default __webpack_public_path__ + "static/media/template3.30492596.png";